import React, { useState, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';

const SelectorUbicacion = ({ 
  value = { pais: '', estado: '', municipio: '' },
  onChange,
  disabled = false,
  isDarkMode = false
}) => {
  const [ubicacionData, setUbicacionData] = useState(null);
  const [loading, setLoading] = useState(false);

  // Cargar toda la estructura al montar el componente
  useEffect(() => {
    loadUbicaciones();
  }, []);

  const loadUbicaciones = async () => {
    setLoading(true);
    try {
      const token = sessionStorage.getItem('mapasac_access_token');
      const response = await fetch('/api/ubicaciones', {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (response.ok) {
        const result = await response.json();
        setUbicacionData(result.data);
      }
    } catch (error) {
      console.error('Error cargando ubicaciones:', error);
    } finally {
      setLoading(false);
    }
  };

  // Obtener estados del país
  const getEstados = () => {
    return ubicacionData?.estados || [];
  };

  // Obtener municipios del estado seleccionado
  const getMunicipios = () => {
    const estados = getEstados();
    const estadoSeleccionado = estados.find(e => String(e.id) === String(value.estado));

    return estadoSeleccionado?.municipios || [];
  };

  const handleEstadoChange = (e) => {
    const estadoId = e.target.value;
    console.log('Nuevo estado seleccionado:', estadoId, typeof estadoId);

    onChange({
      pais: ubicacionData?.pais?.id || '',
      estado: estadoId,
      municipio: ''
    });
  };

  const handleMunicipioChange = (e) => {
    const municipioId = e.target.value;
    onChange({
      pais: ubicacionData?.pais?.id || '',
      estado: value.estado || '',
      municipio: municipioId
    });
  };

  const selectClass = `w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none ${
    isDarkMode 
      ? 'bg-gray-700 border-gray-600 text-gray-400' 
      : 'bg-white border-gray-300 text-gray-900'
  } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`;

  return (
    <div className="grid grid-cols-2 gap-4">
      {/* Estado */}
      <div>
        <label className={`block text-sm font-medium mb-1 ${isDarkMode ? 'text-gray-200' : 'text-gray-700'}`}>
          Estado *
        </label>
        <div className="relative">
          <select
            value={value.estado || ''}
            onChange={handleEstadoChange}
            disabled={disabled || loading}
            className={`${selectClass} ${isDarkMode ? (value.estado ? 'text-white' : 'text-gray-400') : ''}`}
          >
            <option value="">
              {loading ? 'Cargando estados...' : 'Seleccionar estado'}
            </option>
            {getEstados().map(estado => (
              <option key={estado.id} value={estado.id}>
                {estado.nombre}
              </option>
            ))}
          </select>
          <ChevronDown className="absolute right-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400 pointer-events-none" />
        </div>
      </div>

      {/* Municipio */}
      <div>
        <label className={`block text-sm font-medium mb-1 ${isDarkMode ? 'text-gray-200' : 'text-gray-700'}`}>
          Municipio *
        </label>
        <div className="relative">
          <select
            value={value.municipio || ''}
            onChange={handleMunicipioChange}
            disabled={disabled || loading || !value.estado}
            className={`${selectClass} ${isDarkMode ? (value.municipio ? 'text-white' : 'text-gray-400') : ''}`}
          >
            <option value="">
              {loading ? 'Cargando municipios...' : 
               !value.estado ? 'Primero selecciona estado' : 'Seleccionar municipio'}
            </option>
            {getMunicipios().map(municipio => (
              <option key={municipio.id} value={municipio.id}>
                {municipio.nombre}
              </option>
            ))}
          </select>
          <ChevronDown className="absolute right-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400 pointer-events-none" />
        </div>
      </div>
    </div>
  );
};
export default SelectorUbicacion;